import API from 'services/api';

import { ICalculationStatement } from '../models';

export const createAutomaticStatement = (id: string): Promise<ICalculationStatement[]> => {
  return API.post(`/api/accommodation/calculations/${id}/statements/automatic`).then(
    res => res?.data,
  );
};
